import { Link } from "react-router-dom";

import CONFIG from "Config";
import { AppLogo } from "components/AppNavbar/AppLogo";
import { UserMenu } from "components/AppNavbar/UserMenu";
import { SidebarNavItems } from "components/AppSidebar/SidebarNavItems";
import { SIDEBAR_CONTENT_CLASSES } from "components/sidebar/sidebarShell";
import SidebarToggleButton from "components/sidebar/SidebarToggleButton";
import UserStatus from "components/UserStatus/UserStatus";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "components/ui/sidebar";

// Global navigation rail: the authenticated shell's vertical navigation,
// rendered by ProtectedLayout in place of a top header.
export function AppSidebar() {
  return (
    <Sidebar collapsible="icon" role="navigation" aria-label="Main navigation">
      <SidebarHeader className="tw:flex-row tw:items-center tw:gap-2 tw:group-data-[collapsible=icon]:flex-col tw:group-data-[collapsible=icon]:items-center tw:border-b">
        <Link to="/" aria-label="Home" className="tw:shrink-0">
          <AppLogo />
        </Link>
        <div className="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:leading-none tw:group-data-[collapsible=icon]:hidden">
          <span className="tw:text-xs tw:text-sidebar-foreground/70">
            Pleteo
          </span>
          <span className="tw:truncate tw:font-heading tw:text-base tw:font-semibold tw:text-sidebar-foreground tw:leading-none">
            {CONFIG.INSTANCE_NAME}
          </span>
        </div>
        <SidebarToggleButton />
      </SidebarHeader>
      <SidebarContent className={SIDEBAR_CONTENT_CLASSES}>
        <SidebarNavItems />
      </SidebarContent>
      <SidebarFooter className="tw:flex-row tw:items-center tw:justify-between tw:gap-2 tw:group-data-[collapsible=icon]:flex-col tw:group-data-[collapsible=icon]:items-center tw:border-t">
        <UserStatus />
        <UserMenu />
      </SidebarFooter>
    </Sidebar>
  );
}
